import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'
import { useApi } from '@fortem-monorepo/react-spa'
import { SearchSelect, SearchSelectProps } from '@fortem-monorepo/react-ui'

export interface InstrumentIdByTypeInputProps extends Omit<SearchSelectProps, 'options'> {
  instrument_type_id: number
}

export const InstrumentIdByTypeInput: React.FC<InstrumentIdByTypeInputProps> = ({
  instrument_type_id,
  ...props
}) => {
  const api = useApi()

  const query = useQuery({
    queryKey: ['instruments', { instrument_type_id }],
    queryFn: () => api.instruments.getInstrumentsByType([instrument_type_id]),
    enabled: typeof instrument_type_id === 'number' && instrument_type_id > 0,
  })

  const options = useMemo(() => {
    return sortAlphabeticallyByKey(
      (query.data ?? []).map((i) => ({
        label: i.label,
        value: i.value.toString(),
      })),
      'label',
    )
  }, [query.data])

  return <SearchSelect options={options} loading={query.isFetching || props.loading} {...props} />
}
